import ChatbotWidget from "./ChatbotWidget";

function App() {
  return (
    <div className="App">
      <ChatbotWidget />
    </div>
  );
}

export default App;
